const FEATURE_SIDEBAR_ITEMS = {
  job_prospects: { path: '/job_prospects', label: 'Job Prospects', capability: 'canManageJobProspects' },
};

export default FEATURE_SIDEBAR_ITEMS;
